import { createSlice } from "@reduxjs/toolkit";
import {
    getallnotificationACTION,
    notificationChangeStatusACTION,
    getnotificationACTION,
    checkNotificationCountACTION
} from "../actions/notification.Action";

const INITIAL_STATE = {
    notification: {
        data: {},
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
    selectedNotificationDetails: {
        data: {},
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
    statusNotificationDetails: {
        data: {},
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
    checkNotificationCount: {
        data: null,
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
};

const notificationReducer = createSlice({
    name: "notification",
    initialState: INITIAL_STATE,
    reducers: {
        RESET(state, action) {
            state = INITIAL_STATE;
        },
        ResetNotificationState(state, action) {
            state.statusNotificationDetails = INITIAL_STATE.statusNotificationDetails;
            state.selectedNotificationDetails = INITIAL_STATE.selectedNotificationDetails;
        },
        RESET_checkNotification_Count(state, action) {
            state.checkNotificationCount = INITIAL_STATE.checkNotificationCount;
        },
    },
    extraReducers: (builder) => {

        builder.addCase(getallnotificationACTION.fulfilled, (state, action) => {
            state.notification.data = action.payload.data;
            state.notification.apiMsg.status = action.meta.requestStatus;
            state.notification.apiMsg.message = action.payload.message.message;
        });
        builder.addCase(getallnotificationACTION.pending, (state, action) => {
            state.notification.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(getallnotificationACTION.rejected, (state, action) => {
            state.notification.apiMsg.message = action.error.message;
            state.notification.apiMsg.status = action.meta.requestStatus;
        });


        builder.addCase(getnotificationACTION.fulfilled, (state, action) => {
            state.selectedNotificationDetails.data = action.payload.data;
            state.selectedNotificationDetails.apiMsg.status = action.meta.requestStatus;
            state.selectedNotificationDetails.apiMsg.message = action.payload.message.message;
        });
        builder.addCase(getnotificationACTION.pending, (state, action) => {
            state.selectedNotificationDetails.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(getnotificationACTION.rejected, (state, action) => {
            state.selectedNotificationDetails.apiMsg.message = action.error.message;
            state.selectedNotificationDetails.apiMsg.status = action.meta.requestStatus;
        });


        builder.addCase(notificationChangeStatusACTION.fulfilled, (state, action) => {
            state.notification.data.records = state.notification.data.records.map((item) => {

                return {
                    ...item,
                    isNotificationRead: action.meta.arg.id === item.id ? true : item.isNotificationRead
                }
            });

            if (
                state.checkNotificationCount?.data?.totalRecords > 0
            ) {
                state.checkNotificationCount.data.totalRecords -= 1;
            }

            state.statusNotificationDetails.apiMsg.status = action.meta.requestStatus;
            state.statusNotificationDetails.apiMsg.message = action.payload.message.message;
        });
        builder.addCase(notificationChangeStatusACTION.pending, (state, action) => {
            state.statusNotificationDetails.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(notificationChangeStatusACTION.rejected, (state, action) => {
            state.statusNotificationDetails.apiMsg.message = action.error.message;
            state.statusNotificationDetails.apiMsg.status = action.meta.requestStatus;
        });

        builder.addCase(checkNotificationCountACTION.fulfilled, (state, action) => {
            state.checkNotificationCount.data = action.payload.data;
            state.checkNotificationCount.apiMsg.status = action.meta.requestStatus;
            state.checkNotificationCount.apiMsg.message = action.payload.message.message;
        });
        builder.addCase(checkNotificationCountACTION.pending, (state, action) => {
            state.checkNotificationCount.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(checkNotificationCountACTION.rejected, (state, action) => {
            state.checkNotificationCount.apiMsg.message = action.error.message;
            state.checkNotificationCount.apiMsg.status = action.meta.requestStatus;
        });
    },
});

export const { RESET, ResetNotificationState, RESET_checkNotification_Count } = notificationReducer.actions;
export default notificationReducer.reducer;
